import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { formatBillingPrice } from '../../../lib/utils/billingPlans';

const ExtraMinutesOffer = ({
  products = [],
  loading = false,
  selectingId = '',
  onBuy,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div className={`space-y-4 ${className}`}>
      <div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1 flex items-center gap-2">
          <Icon name="Clock" size={18} className="text-primary" />
          {t('billing.buyExtra')}
        </h3>
        <p className="text-sm text-muted-foreground">
          {t('billing.buyExtraDesc')}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
        {products.map((product) => {
          const hasPrice = Boolean(product?.price?.priceId);
          const isSelecting = selectingId === product.id;

          return (
            <div
              key={product.id}
              className="flex flex-col rounded-lg border border-border bg-card p-4 text-center"
            >
              <div className="text-2xl font-semibold text-foreground">
                +{product.minutes}
              </div>
              <div className="text-xs text-muted-foreground mb-3">{t('billing.minutes')}</div>
              <div className="text-base font-medium text-foreground mb-4">
                {formatBillingPrice(product?.price)}
              </div>
              <Button
                variant="outline"
                size="sm"
                className="mt-auto"
                disabled={loading || !hasPrice || isSelecting}
                loading={isSelecting}
                onClick={() => onBuy?.({ product, price: product?.price })}
              >
                {t('billing.buy')}
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExtraMinutesOffer;
